__turbopack_context__.v({
  "cardContainer": "serviceCardsCard-module-scss-module__E-64fW__cardContainer",
  "cardDescription": "serviceCardsCard-module-scss-module__E-64fW__cardDescription",
  "cardTitle": "serviceCardsCard-module-scss-module__E-64fW__cardTitle",
  "cardWrapper": "serviceCardsCard-module-scss-module__E-64fW__cardWrapper",
});
